import { createRouter, createWebHistory } from 'vue-router'
import { storeToRefs } from 'pinia'
import NotFound from '@pages/NotFound.vue'
import { generateRoutes, authRoutes } from '@utils/menus.utils'
import { hasAccess } from '@utils/helper.utils'
import { useAlertStore, useAuthStore } from '@store'
import { getSentryService } from '@/services/sentryService'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...authRoutes,
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
  ],
})

// Function to add routes dynamically
export const setupRouter = async (accountData) => {
  const routes = await generateRoutes(accountData)
  routes.forEach((route) => {
    router.addRoute(route)
  })
}

router.beforeEach((to, from, next) => {
  window.loading.value = true
  const sentry = getSentryService()
  sentry?.endFlow({ reason: 'navigation_interrupt' })
  // clear alert on route change
  const alertStore = useAlertStore()
  alertStore.clear()

  const authStore = useAuthStore()
  const { accountData } = storeToRefs(authStore)

  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [
    '/auth/login',
    '/register',
    'activate-card', // to-do: remove after auth route is implemented
    '/auth/activate-card',
    '/auth/sign-up',
    '/auth/set-password',
    '/auth/forgot-password',
    '/auth/update-password',
  ]
  const authRequired = !publicPages.includes(to.path)

  if (!authRequired) {
    next()
  } else if (authRequired && !authStore.isAuthenticated) {
    next('/auth/login')
  } else {
    // Ensure routes are loaded
    if (!router.hasRoute('dashboard') && accountData.value) {
      setupRouter(accountData.value).then(() => {
        next(to.fullPath) // Redirect to same route after adding routes
      })
    } else if (hasAccess(to.meta, accountData.value)) {
      next()
    } else {
      next('/auth/login')
    }
  }
})

router.afterEach(() => {
  window.loading.value = false
})

export default router
